
// SCRIPTS
import { GeneralHomePage } from './home/home.page'; export { GeneralHomePage };
import { ResearchCenterPage } from "./research-centers/template/scripts/research-center.page"; export { ResearchCenterPage }
import { LoginPage } from "./../auth/pages/login/login.page"; export { LoginPage }


// STYLES
import './home/home.scss';
import './about/about-us.scss';
import './research-centers/template/research-centers.scss';

